import React from "react";
import { Text } from "@jsq/ds/core";
import { formatDateLabelUtc, getLocalDateKeyUtc } from "../../../../utils/date_formatter";
import { dateGroupLabelText } from "../styles_vanilla.css";
import type { ActivityEvent } from "../types";
import type { TimelineItem } from "./types";

export const formatDateGroupLabel = (isoString: string): React.ReactNode => {
  const label = formatDateLabelUtc(isoString);
  if (!label) return null;
  if (label.isToday) {
    return (
      <>
        <Text variant="strong-sm" className={dateGroupLabelText}>
          Today
        </Text>
        <Text variant="strong-sm" className={dateGroupLabelText}>
          {label.longDate}
        </Text>
      </>
    );
  }
  return (
    <Text variant="strong-sm" className={dateGroupLabelText}>
      {label.longDate}
    </Text>
  );
};

export const buildActivityTimelineItems = (
  events: ActivityEvent[],
  renderContent: (event: ActivityEvent) => React.ReactNode,
): TimelineItem[] => {
  const sorted = [...events].sort((a, b) => b.timestamp.localeCompare(a.timestamp));
  let lastDayKey = "";
  return sorted.map((event) => {
    const dayKey = getLocalDateKeyUtc(event.timestamp);
    const showLabel = dayKey !== lastDayKey;
    lastDayKey = dayKey;
    return {
      id: event.id,
      label: showLabel ? formatDateGroupLabel(event.timestamp) : undefined,
      content: renderContent(event),
    };
  });
};
